// extracted by mini-css-extract-plugin
module.exports = {"author":"bs_jh","author__avatar":"bs_jj","author__img":"bs_jk","author__text":"bs_jl"};